import { Command } from "./communicationDefinitions";
import crc from "crc";

export enum PourOverPattern {
  MID = 0,
  CIRCLE = 1,
  SPIRAL = 2,
}

export enum Shake {
  NONE = 0,
  BEFORE = 1,
  AFTER = 2,
  BOTH = 3,
}

export type StageData = {
  weight: number;
  temperature: number;
  pattern: PourOverPattern;
  shake: Shake;
  time: number;
  grindRPM: number;
  flowRate: number;
};

export interface DeviceProfile {
  stages: StageData[]; // Array of stage data
  grindSize: number; // 1-100
  brewRatio: number; // Brew ratio * 10
}

export const formatProfile = (profile: DeviceProfile) => {
  const stagesData = profile.stages.flatMap((stage) => [
    stage.weight,
    stage.temperature,
    stage.pattern,
    stage.shake,
    (0x100 - stage.time) & 0xff,
    0x00,
    stage.grindRPM,
    Math.round(stage.flowRate * 10),
  ]);

  const totalProfileLength = stagesData.length;

  const profileHeader = new Uint8Array([totalProfileLength]);

  const profileTail = new Uint8Array([
    profile.grindSize,
    Math.round(profile.brewRatio * 10),
  ]);

  const data = new Uint8Array([
    ...profileHeader,
    ...stagesData,
    ...profileTail,
  ]);
  return formatCommand(Command.CMD_SEND_RECIPE, data);
};

export const formatBypass = (bypassML: number, temp: number) => {
  const buffer = new ArrayBuffer(12);
  const data = new DataView(buffer);
  // Bypass in ml as float32 (BE)
  data.setFloat32(0, bypassML, true);
  // Temp in C as float32 (BE)
  data.setFloat32(4, temp * 10, true);
  // Unknown
  const unknown1 = 0x12;
  data.setUint32(8, unknown1, true);

  return formatCommand(Command.CMD_INFO_BYPASS, new Uint8Array(data.buffer));
};

export const formatCommand = (command: number, payload?: Uint8Array) => {
  const header = new Uint8Array([
    0x58, // 'X'
    0x01, // to device
    0x01, // device id
    command & 0xff,
    (command >> 8) & 0xff,
    0x00, // LENGTH Placeholder
    0x00,
    0x00,
    0x00,
    0x01,
  ]);

  const length = header.length + 2 + (payload ? payload.length : 0);
  header[5] = length;

  const data = new Uint8Array([...header, ...(payload || [])]);

  const crc16 = crc.crc16kermit(data, 0);
  return new Uint8Array([...data, crc16 & 0xff, (crc16 >> 8) & 0xff]);
};
